/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, { useRef, useState, useCallback } from 'react'
import Debounce from '../../../../CommonMethods/Debounce'
import { useOnClickOutside } from '../../../../CommonMethods/OutsideClick'
import { GetBranchId } from '../../../../CommonMethods/GetBranchId'
import { dataService } from '../../../../services/data.services'
import { ShimmerTitle } from 'react-shimmer-effects';

export default function LedgerSearch({
    handleSearchFiled,
    handleSchemeLedgerValidation, 
    index,
    multiField,
    setMultiField,
    submitSelected,
    setToastErrorMessage,
    AccountType,
    AccountOption,
    singleAccount, 
    setSingleAccount,
    accountNameError,
    setAccountNameError,
    LegerEndpoint,
    setSingleAccountId,
    singleAccountId,
    setsubmitSelected,
    setSelectedAmountIndex,
    setSchemeStudentsData,
    setSchemeLedgerId,
    searchParams,
    setSearchParams
}) {
    const inputRef=useRef()
    const [dropdownData, setDropdownData] = useState([])
    const [isSearching, setIsSearching] = useState(false)
    useOnClickOutside(inputRef, () => {
        setDropdownData([]);
    });

    const handelSearchInput = useCallback(
        Debounce((value, selectedMultiField, selectedAccountFelid) => handelSearchInputDebounce(value, selectedMultiField, selectedAccountFelid)),
        []
    );
    const handelSearchInputDebounce = (value, selectedMultiField, selectedAccountFelid) => {
        if(setSelectedAmountIndex) {
            setSelectedAmountIndex(null);
        }
        if(setsubmitSelected) {
            setsubmitSelected(false)
        }
        const timer=setTimeout(async ()=>{
            let searchValue = encodeURIComponent(value).replace(/[#&]/g, '\\$&').trim()
            if(searchValue.trim() !== "") {   
                // let copy = copyParams.delete("fy_status")
                try{
                    const branch_id = await GetBranchId()
                    let endPoint = "";
                    if(LegerEndpoint === "receipt" || LegerEndpoint === "payment" || LegerEndpoint === "RTE-Scholarship") {
                        if(AccountType === "Source") {
                            endPoint = "&source_account=true"
                        } else {
                            endPoint = "&destination_account=true"
                        }
                    } 
                    const res = await dataService.GetAPI(`groups-and-ledgers?branch_id=${branch_id}&type=ledger&search=${searchValue}&status=active&filter=true&voucher_type=${LegerEndpoint}${endPoint}&role=vouchers-entry`);
                    if(LegerEndpoint === "receipt" && AccountOption === "single" ) {
                        const itemNames = new Set();

                        // Store unique item names from arr1
                        selectedMultiField.forEach(item => {
                            itemNames.add(item.account_name);
                        });
                    
                        // Remove items with duplicate names from arr2
                        const filteredArr2 = res.data.data.data.filter(item => !itemNames.has(item.parent_group_name_composite_key));
                        setDropdownData(filteredArr2);
                    }else if(LegerEndpoint === "receipt" && AccountOption === "multi" ) {                    
                        const filteredArr2 = res.data.data.data.filter(item => selectedAccountFelid !== item.parent_group_name_composite_key);
                        setDropdownData(filteredArr2);
                    } else {
                        setDropdownData(res.data.data.data)
                    }
                }catch(error){
                    console.log("error", error)
                    setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
                } finally {
                    setIsSearching(false)
                }
            } else {
                setDropdownData([])
                setIsSearching(false)
            }
        },500)
        return()=>{
            clearTimeout(timer)
        }
    }
    const val = AccountOption === "single" ? singleAccount : multiField[index].account_name;
    return (
        <div class={`relative ${LegerEndpoint === "journal" ? "w-[227px]" : LegerEndpoint === "payment" ? "w-[200px]" : "w-[245px]"} `} ref={inputRef}>
            <input 
                type="text" 
                id={`${AccountType}_account_name`}
                title={AccountOption === "single" ? singleAccount : multiField[index].account_name}
                // className={`border  ${(submitSelected && multiField[index].item_name === "" || selectedErrorState === index) ? "border-[#F04438]" : "border-[#D0D5DD]"} bg-white rounded w-full px-3.5 py-1.5 text-f7 font-normal text-[#101828] placeholder:text-f7 placeholder:text-normal placeholder:text-[#818E98] outline-0 error_border`} 
                className={`${((accountNameError || submitSelected) && (AccountOption === "single" ? singleAccountId === "" : multiField[index].account_id === "")) ? "redBorder" : ""}   slct-inpt-fld`} 
                style={{'padding-right':'35px'}}
                placeholder="Select Account" 
                autocomplete="off" 
                onChange={e=>{
                    handelSearchInput(e.target.value, multiField, singleAccount)
                    if(e.target.value.trim() !== "") {
                        setIsSearching(true)
                        setDropdownData([])
                    } else {
                        setIsSearching(false)
                        setDropdownData([])
                    }
                    setAccountNameError(false)
                    if(AccountOption === "single" ) {
                        setSingleAccount(e.target.value)
                        setSingleAccountId("")
                        if(AccountType === "Source" && LegerEndpoint === "RTE-Scholarship" && setSchemeStudentsData){
                            setSchemeStudentsData([])
                            setSchemeLedgerId(undefined)
                            const params = Object.fromEntries(searchParams);
                            delete params.search;
                            setSearchParams({
                                ...params,
                                student_page_number: 1,
                            });
                        }
                    } else {
                        let updatedFields = [...multiField];
                        updatedFields[index] = {
                            ...updatedFields[index],
                            account_name: e.target.value,
                            account_id: ""
                        };
                        const { 
                            invoice_reference_number, 
                            invoice_date, 
                            invoice_reference_number_id, 
                            account_number, 
                            actual_pending_amount, 
                            ...remainingFields 
                        } = updatedFields[index];
                        
                        updatedFields[index] = {
                            ...remainingFields
                        };
                        setMultiField([...updatedFields]);
                    }
      
                    // setSelectedErrorState(null)
                    setToastErrorMessage("")
                }}
                value={val.substring(val.lastIndexOf('>')+1) || ""}
            />
            <button class="absolute top-[50%] -translate-y-[50%] right-2">
                <img loading="lazy" decoding="async" src="/images/search.svg" alt="img" />
            </button>
            {(isSearching || dropdownData?.length>0) && <ul class="slct_drp_dwn min-w-full [&[data-te-dropdown-show]]:block select_student" aria-labelledby="dropdownMenu_acdemic_year" data-te-dropdown-menu-ref>
                {isSearching ? (
                    <li className="max-h-[150px] overflow-auto scroll-bar" style={{ 'padding': '0.3rem 0.5rem' }}>
                        <p className="text-2xl font-bold text-[#031624] mb-4 mt-4"><ShimmerTitle line={1} gap={6} variant="secondary" /></p>
                    </li>
                ) : (
                    <li class="max-h-[150px] overflow-auto scroll-bar" >
                        {dropdownData?.map((search_item)=>(
                            <ul key={search_item}>
                                {
                                    <li>
                                        <a
                                            class="slct_drp_dwn_optn selected_Class" 
                                            onClick={() => {
                                                setDropdownData([]);
                                                handleSearchFiled(index, search_item); 
                                                if(handleSchemeLedgerValidation) {
                                                    handleSchemeLedgerValidation(index, search_item);
                                                }
                                            }} 
                                            title={search_item.parent_group_name_composite_key}
                                        >{search_item.parent_group_name_composite_key}
                                        </a>
                                    </li>
                                }
                            </ul>
                        ))
                    
                        } 
                    </li>
                )}
            </ul>}
        </div>  
    )
}
